import React, { type FC } from "react";
import {
	Button,
	BUTTON_SIZE_LG,
	BUTTON_VARIANT_PRIMARY,
} from "mailup-web-components";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { gainsightTrack } from "mailup-react-helpers";

export const CombinedFilterAddButton: FC = () => {
	const intl = useIntl();
	const navigate = useNavigate();
	const goToForm = (): void => {
		gainsightTrack("mup_filters_click_createNewFilter", {
			
		});
		navigate("/filters/form/0");
	};
	return (
		<Button
			kind={BUTTON_VARIANT_PRIMARY}
			size={BUTTON_SIZE_LG}
			mup_filters_click_createNewFilter
			data-mu-test="filter__cta-new"
			onClick={goToForm}
		>
			{intl.formatMessage({ id: "Load.FiltersList.AddFilter" })}
		</Button>
	);
};
